import { SwiperScreenSizes } from '@interfaces/index';
import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  const { appTheme } = useMytaverse();

  return {
    swiperWrap: {
      '& .swiper-slide': {
        [breakpoints.down(SwiperScreenSizes.Mobile1)]: {
          display: 'flex',
          justifyContent: 'center',
        },
      },
      '& .swiper-pagination-bullet-active': {
        background: appTheme.mainColor,
      },
    },
  };
};
